<template>
  <div class="home">
    <div class="head-title">腾讯云设置</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <h2 class="a" style="margin-top: 2.0rem">OSS设置</h2>
          <el-form ref="form" :model="form" label-width="20.0rem">
            <el-form-item label="Bucket">
              <el-input style="width:30%;" clearable v-model="form.tableData.bucket"></el-input>
            </el-form-item>
            <el-form-item label="Endpoint域名">
              <el-input style="width:30%;" clearable v-model="form.tableData.domain_name"></el-input>
            </el-form-item>
            <el-form-item label="AccessKey ID">
              <el-input style="width:30%;" clearable v-model="form.tableData.accesskey_id"></el-input>
            </el-form-item>
            <el-form-item label="Access Key Secret">
              <el-input style="width:30%;" clearable v-model="form.tableData.access_key_secret"></el-input>
            </el-form-item>
            <h2 class="b">短信设置</h2>
            <el-form-item label="短信签名">
              <el-input style="width:30%;" clearable v-model="form.tableData.sign"></el-input>
            </el-form-item>
            <el-form-item label="注册验证码模板ID">
              <el-input style="width:30%;" clearable v-model="form.tableData.template1"></el-input>
            </el-form-item>
            <el-form-item label="找回密码验证码模板ID">
              <el-input style="width:30%;" clearable v-model="form.tableData.template2"></el-input>
            </el-form-item>
            <el-form-item label="业务开通短信模板ID">
              <el-input style="width:30%;" clearable v-model="form.tableData.template3"></el-input>
            </el-form-item>
            <el-form-item label="登录验证码模板ID">
              <el-input style="width:30%;" clearable v-model="form.tableData.template4"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">修改</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      form: {
        tableData: [],
      },
      tooken: "",
      title: {},
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
    }
    this.axios
      .post(
        "/api/OssNoteSet/getOssNoteSet",
        qs.stringify({
          totaltoken: this.tooken.totaltoken,
          id: "2",
        }),
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      )
      .then((res) => {
        this.form.tableData = res.data.data;
        if (res.data.msg == "登录超时") {
          this.$router.push("/Tagent");
        }
      })
      .catch(function (err) {});
  },
  methods: {
    //tooken验证
    // 提交过后输出的数据\
    onSubmit() {
      this.axios
        .post(
          "/api/OssNoteSet/editOssNoteSet",
          qs.stringify({
            id: this.form.tableData.id,
            bucket: this.form.tableData.bucket,
            domain_name: this.form.tableData.domain_name,
            accesskey_id: this.form.tableData.accesskey_id,
            access_key_secret: this.form.tableData.access_key_secret,
            sign: this.form.tableData.sign,
            template1: this.form.tableData.template1,
            template2: this.form.tableData.template2,
            template3: this.form.tableData.template3,
            template4: this.form.tableData.template4,
            totaltoken: this.tooken.totaltoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
  },
  // 1.用户分配
  // 2.用户分配
  //3.用户选择 附件管理
};
</script>
<style scoped>
h2 {
  color: #606266;
  left: 11.0rem;
  margin-bottom: 3.0rem;
  font-size: 2.0rem;
}
.b {
  margin-left: 95px;
}
.a {
  margin-left: 114px;
}
.home{
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0,0,0,0.1);
}
.body_html{
  width: 100%;
  height: 100%;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 23px 31px;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 26px;
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
</style>


